import { useSyncExternalStore } from "react";

/**
 * Detect whether the mobile on-screen keyboard is currently open.
 *
 * Uses the VisualViewport API: when the keyboard opens, the visual viewport
 * height shrinks well below the layout viewport (window.innerHeight).  A
 * threshold of 150px separates the two states robustly — URL bar
 * show/hide only swings the visual viewport by ~60-80px, whereas the
 * keyboard takes 200+px.
 *
 * Returns false on desktop (no visualViewport or no meaningful gap),
 * during SSR, and whenever the visual viewport is not significantly
 * smaller than the layout viewport.
 */
function subscribe(callback: () => void) {
  const vv = window.visualViewport;
  if (!vv) return () => {};
  vv.addEventListener("resize", callback);
  vv.addEventListener("scroll", callback);
  return () => {
    vv.removeEventListener("resize", callback);
    vv.removeEventListener("scroll", callback);
  };
}

function getSnapshot(): boolean {
  const vv = window.visualViewport;
  if (!vv) return false;
  // Compare against the layout viewport rather than a fixed pixel value
  // so desktop window resizing and pinch-zoom (which also fire
  // visualViewport.resize) don't trigger a false positive.
  return vv.height < window.innerHeight - 150;
}

function getServerSnapshot(): boolean {
  return false;
}

export function useIsKeyboardOpen(): boolean {
  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}
